import styled from 'styled-components';
import {
  JourneyNode,
  Text,
} from '@usealloy/component-library';

export const SubHeader = styled(Text)`
  && {
    margin-bottom: var(--cl-space-3);
    color: var(--cl-text-secondary);
  }
`;

export const WorkflowNode = styled(JourneyNode)`
  &:hover {
    background-color: var(--cl-gray-400);
  }
`;

export const Wrapper = styled.div`
  &:not(:last-child) {
    margin-bottom: var(--cl-space-2);
  }
`;
